import { Injectable } from '@angular/core';
import { PublicationFileTable, PublicationFileTableSchema } from 'src/app/infra/database/dexie/instance/action/schema/publicationFile';
import { actionDatabase } from 'src/app/infra/database/dexie/instance/action/service';
import { DexieRepository } from 'src/app/infra/repository/dexie/dexie-repository.service';

@Injectable({
  providedIn: 'root'
})
export class PublicationFileLocalRepositoryService extends DexieRepository<PublicationFileTable, PublicationFileTable> {

  constructor() {
    super(actionDatabase.publicationFile, PublicationFileTableSchema, actionDatabase)
  }
}
